import { Box, Typography } from '@mui/material';
import { YesNo } from '@uplift/types';
import { useFormikContext } from 'formik';
import { IsPrimarySubscriberForm } from './is-primary-subscriber-form.form';
import { PrimarySubscriberForm } from './primary-subscriber-form.form';
import { InsuranceFormType } from '../hooks/use-insurance-form.hook';
import { useL10n } from '@uplift/hooks';
import { AddressForm } from './address-form.form';
import { useStatesQuery } from '@uplift/queries';

export type PrimarySubscriberFormBlockType = {
  isMobile?: boolean;
  isModal?: boolean;
  isAddInsurance?: boolean;
  patientId?: string;
};

export const PrimarySubscriberFormBlock: React.VFC<PrimarySubscriberFormBlockType> = ({ isMobile = false, patientId, isModal }) => {
  const l10n = useL10n();
  const formik = useFormikContext<InsuranceFormType>();
  const isPrimary = formik.values.isPrimarySubscriber === YesNo.Yes;
  const { data: states } = useStatesQuery();

  const renderSubSectionHeader = (header: string) => {
    return (
      <Box mt={5} mb={isMobile ? 1 : 3}>
        <Typography variant="overline" color={isModal ? 'secondary' : 'primary'}>{header}</Typography>
      </Box>
    );
  };

  const detailsHeader = renderSubSectionHeader(l10n.accountSettings.insurance.primarySubscriberDetails);
  const addressHeader = renderSubSectionHeader(l10n.accountSettings.insurance.primarySubscriberAddress);

  const renderPrimarySubsciberForm = () => {
    return (
      <>
        {detailsHeader}
        <PrimarySubscriberForm />
        {addressHeader}
        <AddressForm states={states ?? []} />
      </>
    );
  };

  return (
    <>
      <IsPrimarySubscriberForm patientId={patientId ?? ''} />
      {!isPrimary && renderPrimarySubsciberForm()}
    </>
  );
};
